// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gARpu","col":"styles_col__1Uar4"};